import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  state('*', style({
    'overflow-y': 'hidden',
  })),
  state(':enter', style({
    'height': '*',
    'margin-top': '*',
    'margin-bottom': '*',
    'padding-top': '*',
    'padding-bottom': '*',
  })),
  state(':leave', style({
    'height': '0',
    'margin-top': '0',
    'margin-bottom': '0',
    'padding-top': '0',
    'padding-bottom': '0',
  })),
  transition(':enter', [
    style({
      'height': '0',
      'margin-top': '0',
      'margin-bottom': '0',
      'padding-top': '0',
      'padding-bottom': '0',
      'transform': 'translateZ(0)'
    }),
    animate('{{time}} ease-in-out', style({
      'height': '*',
      'margin-top': '*',
      'margin-bottom': '*',
      'padding-top': '*',
      'padding-bottom': '*',
    }))
  ], {params: {time: '500ms'}}),
  transition(':leave', [
    style({
      'height': '*',
      'margin-top': '*',
      'margin-bottom': '*',
      'padding-top': '*',
      'padding-bottom': '*',
      'transform': 'translateZ(0)'
    }),
    animate('{{time}} ease-in-out', style({
      'height': '0',
      'margin-top': '0',
      'margin-bottom': '0',
      'padding-top': '0',
      'padding-bottom': '0',
    }))
  ], {params: {time: '500ms'}})
]);

export const hiddenElementSlideInOut = trigger('hiddenElementSlideInOut', [
    state('open', style({
      'height': '*',
      'overflow': 'inherit'
    })),
    state('expanded', style({
      'height': '*',
      'overflow': 'hidden'
    })),
    state('closed', style({
      'height': '0',
      'margin-top': '0',
      'margin-bottom': '0',
      'padding-top': '0',
      'padding-bottom': '0',
      'overflow': 'hidden'
    })),
    transition('* => *', [
      animate('{{time}}')
    ], {params: {time: '400ms'}})
  ]);
